export enum Constants {
  IS_OFFLINE = "IS_OFFLINE",
  SET_USER = "SET_USER",
  SET_REPO = "SET_REPO",
  SET_ERROR = "SET_ERROR",
  RESET = "RESET",
}
